//
// FolderManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";

var FolderManager = createModule("transport::FolderManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getReportFolderItemFromPath: [1,7],
        getFolderContentFromPath: [1,7],
        getFolderItemFromPathForFolder: [1,7],
        getFolderContent: [1,1],
    },
    ,
    ,
]);
export default FolderManager;
